import axios from 'axios'
import AxiosMockAdapter from 'axios-mock-adapter'
import authService from '../utils/authService'

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')

const axiosInstance = axios.create({
  baseURL: baseUrl + 'api',
})

axiosInstance.interceptors.request.use(
  (request) => {
    const token = authService.getJwtToken()
    if (token) {
      request.headers = {
        Authorization: `Bearer ${token}`,
      }
      const adminToken = authService.getAdminToken()
      if (adminToken) request.headers['AdminBearer'] = adminToken
    }
    return request
  },
  (error) => {
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    const originalRequest = error.config
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.headers['token-expired'] &&
      !originalRequest.retry &&
      authService.isAuthenticated()
    ) {
      originalRequest.retry = true

      return axiosInstance
        .post('/token/refresh', {
          token: authService.getJwtToken(),
          refreshToken: authService.getRefreshToken(),
          deviceId: authService.getDeviceId(),
        })
        .then(({data: refreshResponse}) => {
          const {token} = refreshResponse
          authService.setJwtToken(token)

          return axios({
            ...originalRequest,
            headers: {
              ...originalRequest.headers,
              Authorization: `Bearer ${token}`,
            },
          })
        })
        .catch(() => {
          axiosInstance
            .post('/account/logout', {
              refreshToken: authService.getRefreshToken(),
              deviceId: authService.getDeviceId(),
            })
            .finally(() => {
              authService.deleteRefreshToken()
              authService.deleteJwtToken()
              authService.clearSession()
            })
        })
    }

    return Promise.reject(error)
  }
)

export const mock = new AxiosMockAdapter(axiosInstance, {
  delayResponse: 1500,
  onNoMatch: 'passthrough',
})

export default axiosInstance
